import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

client.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("gp_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default client;

// Display helpers ---------------------------------------------------------
export const displayName = (p) => {
  if (!p) return "";
  const d = (p.short_description || "").trim();
  if (d && d.toLowerCase() !== (p.name || "").toLowerCase()) return d;
  return p.name || p.sku;
};

export const priceLabel = (p) => {
  if (p && p.admin_price !== null && p.admin_price !== undefined) {
    return `$${Number(p.admin_price).toFixed(2)} CAD`;
  }
  return (p && p.price_display) || "Request Quote";
};

export const hasPrice = (p) => p && p.admin_price !== null && p.admin_price !== undefined;
